<template>
  <div class="container">
    <section class="section">
      <h1 class="title dontprint">Comisiones</h1>
      <div class="buttons are-medium dontprint">
        <router-link
          class="button"
          :class="classbutton('edades')"
          :to="{ name: 'comision.edades' }"
          >Edades</router-link
        >
        <router-link
          class="button"
          :class="classbutton('vendedores')"
          :to="{ name: 'comision.vendedores' }"
          >Vendedores</router-link
        >
        <router-link
          class="button"
          :class="classbutton('clientes')"
          :to="{ name: 'comision.clientes' }"
          >Clientes</router-link
        >
        <router-link
          class="button"
          :class="classbutton('producto')"
          :to="{ name: 'comision.producto' }"
          >Producto</router-link
        >
        <router-link
          class="button"
          :class="classbutton('cartera')"
          :to="{ name: 'comision.cartera' }"
          >Cartera</router-link
        >
        <router-link
          class="button"
          :class="classbutton('comisiones')"
          :to="{ name: 'comision.comisiones' }"
          >Comisiones</router-link
        >
      </div>
      <hr class="dontprint" />
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    ruta() {
      return this.$route.name;
    },
  },
  methods: {
    classbutton(name) {
      if (`comision.${name}` === this.ruta) {
        return "is-link";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .dontprint {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comisiones/Comision.vue